import {
  RESET_PROJECT,
  SET_ARCHITECTURE,
  SET_ORGANIZATION_UUID,
  SET_PIXEL_KEYS,
  SET_PROJECT,
  SET_PROJECT_UUID,
  SET_STRIPE_CLIENT_ACCOUNT,
  SET_STRIPE_CONNECT_ID,
  SET_STRIPE_KEY,
} from "./ActionTypes";

import type {
  ResetProjectAction,
  SetArchitectureAction,
  SetOrganizationUuidAction,
  SetPixelKeysAction,
  SetProjectAction,
  SetProjectUuidAction,
  SetStripeClientAccountAction,
  SetStripeConnectIdAction,
  SetStripeKeyAction,
} from "./architecture.types";
import type { Architecture, PixelKeys } from "../reducers/architecture.types";

export const setSiteArchitecture = (
  architecture: Architecture,
): SetArchitectureAction => ({
  type: SET_ARCHITECTURE,
  architecture,
});

export const setStripeKey = (key: string): SetStripeKeyAction => ({
  type: SET_STRIPE_KEY,
  key,
});

export const setStripeClientAccount = (
  key: string,
): SetStripeClientAccountAction => ({
  type: SET_STRIPE_CLIENT_ACCOUNT,
  key,
});

export const setPixelKeys = (
  ga_key: PixelKeys["ga_key"],
  fb_key: PixelKeys["fb_key"],
): SetPixelKeysAction => ({
  type: SET_PIXEL_KEYS,
  keys: {
    ga_key,
    fb_key,
  },
});

export const setProjectUuid = (uuid: string | null): SetProjectUuidAction => ({
  type: SET_PROJECT_UUID,
  uuid,
});

export const setOrganizationUuid = (
  uuid: string,
): SetOrganizationUuidAction => ({
  type: SET_ORGANIZATION_UUID,
  uuid,
});

export const setProject = ({
  project,
  projectSlug,
}: {
  project: SetProjectAction["project"];
  projectSlug: SetProjectAction["projectSlug"];
}): SetProjectAction => ({
  type: SET_PROJECT,
  project,
  projectSlug,
});

export const resetProject = (): ResetProjectAction => ({
  type: RESET_PROJECT,
});

export const setStripeConnectId = (
  client_id: string,
): SetStripeConnectIdAction => ({
  type: SET_STRIPE_CONNECT_ID,
  client_id,
});
